import { UiComponents, UnoStoreHooks, DashboardIcon } from "@simulanisindia/ui";
import { useNavigate } from "react-router-dom";
import {ProjectListiIcon } from "../../assets/icons/icons";

const { useUnoSelector } = UnoStoreHooks;
const { Sidebar: UISidebar } = UiComponents;

const Sidebar = () => {
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);

  const MainMenuItems = [
    {
      id: 1,
      key: "dashboard",
      tooltip: "Team Dashboard",
      icon: <DashboardIcon />,
      clickHandler: () => navigate(`/dashboard/${userData?.user?.group?.uuid}`),
    },
  ];

  const menuItems = [
    {
      id: 2,
      key: "project",
      tooltip: "Project List",
      icon: <ProjectListiIcon />,
      clickHandler: () => navigate(`/project/${userData.user.uuid}`),
    },
  ];

  return (
    <>
      <UISidebar mainMenuItems={MainMenuItems} menuItems={menuItems} />
    </>
  );
};

export default Sidebar;